
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-dash");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/dash/index.js
// module id = eOt4
// module chunks = 11